import * as React from "react";
import Dropzone from "react-dropzone";


export type FileUploadProps = {
    type: "image" | "video" | "both",
    uniqueId: number,
    uploadedFiles: string,
    uploadingFile: boolean,
    disableDropZone: boolean
};

export type FileUploadActions = {
    onChange(value: string): void,
    onDrop(acceptedFiles: File[], rejectedFiles: File[]): void
};

export type FileUploadPropsAndActions = FileUploadProps & FileUploadActions;

class FileUpload extends React.PureComponent<FileUploadPropsAndActions, any> {
    //Since we want to store the file name as it's stored, we need to do this on a response from the server, so this will force RRF to acknowledge the change when it happens
    componentDidUpdate(prevProps: FileUploadPropsAndActions) {
        if (prevProps.uploadedFiles != this.props.uploadedFiles) {
            this.props.onChange(this.props.uploadedFiles);
        }
    }

    render() {
        var accept: string;

        // TODO: Put these somewhere more global
        const imageTypes = "image/*";
        const videoTypes = "video/*";

        switch (this.props.type) {
            case "image":
                accept = imageTypes;
                break;
            case "video":
                accept = videoTypes;
                break;
            case "both":
                accept = `${imageTypes},${videoTypes}`
                break;
        }

        return ([
            this.props.disableDropZone || this.props.uploadingFile ? undefined :
                /*<Dropzone
                    accept={accept}
                    activeClassName="drop-zone-container-active"
                    key={`FileUpload${this.props.uniqueId}.Dropzone`}
                    onDrop={(acceptedFiles: File[], rejectedFiles: File[]) => {
                        //this.props.onChange(acceptedFiles.length > 0 ? acceptedFiles.map(file => file.name).join(",") : "[none]");
                        this.props.onDrop(acceptedFiles, rejectedFiles);
                    }}
                    className="drop-zone-container mt-2 clickable"
                    disabledClassName="drop-zone-container-disabled"
                    maxSize={4126939}
                    disabled={this.props.disableDropZone || this.props.uploadingFile}
                >
                    <div className="text-center mt-2 mb-2">
                        <i
                            className="fa fa-camera fa-3x text-muted"
                            aria-hidden="true"
                        />
                        <br />
                        Drop files here, or click to select files to upload.
                </div>
                </Dropzone>,*/
            this.props.uploadedFiles ?
                <div key={`FileUpload${this.props.uniqueId}.Div`}>
                    <ul
                        className="list-group"
                        key={`FileUpload${this.props.uniqueId}.Ul`}
                    >
                        {this.props.uploadedFiles.split(",").map((fileName, i) =>
                            <li
                                className="py-2 list-group-item"
                                key={`FileUpload${this.props.uniqueId}.Li.${i}`}
                            >
                                <small>{fileName.split(" - ")[1]}</small>
                            </li>
                        )}
                    </ul>
                </div> :
                undefined
        ]);
    }
}

export default FileUpload;
